export const agentsRoute = {
    patterns: {
        agents: '/agents',
    },
} as const;
